module.exports = __webpack_public_path__ + "static/media/progress_bar_1.90b20902.svg";